<template>
  <div id="MessageCreate">
    <!-- success msg component 
    <Success :msg="msg" v-show="success" />
    <ProductForm :user="user" @submit-form="saveUser" hasCustomer=true buttonText="Guardar" />
     -->
    <ProductForm :submitForm="addRow" buttonText="Guardar" hasReset=true hasMessage=true />
  </div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
import ProductForm from "@/components/MessageForm";
//import Success from "./Success";
// import baseApi from '@/services/baseApi';
import icheckApi from '@/services/icheckApi';
// import router from '@/router';

export default {
  name: "MessageCreate",
  computed:{
    ...mapState(['currentUser']),    
  },
  components: {
    ProductForm,
    //Success,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      success: false,
      msg: "",
      sfecha:new Date().toISOString().substr(0,10),
    };
  },
  methods: {
    ...mapMutations(["showLoading","hiddenLoading","changeBreadcrumbs"]),
    async addRow(MessageInfo){
        // alert("Agregar Evento");
        // alert (MessageInfo.fecha_fin);
        try{ 
          this.showLoading({titulo:"Almacenando información",color:"warning"})
          let title=MessageInfo.title;
          let name=MessageInfo.name;
          let type=MessageInfo.tipo;
          let date_send=this.sfecha;
          //let customer_id=MessageInfo.customer_id;
          //let fecha_inicio=MessageInfo.fecha_inicio;
          //let fecha_fin=MessageInfo.fecha_fin;
          //let notes=MessageInfo.notes;
          // const { salesorder_id,customer_id,fecha_inicio,cantidad } = this;        
          //let datos=await baseApi().post();          

          await icheckApi().post(`/mensajes`,JSON.stringify({ title,name,type,date_send })).then((response)=>{
              if(!response.data.error){                            
                // this.$swal("Genial!","", "success");
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                    
              // console.log("VENTA: "+response.data.message);
          });
        }catch(error){
          //console.log(error);
          this.$swal("Error!",error.message+"<br/> Intente Nuevamente o verifique todos los campos", "error");
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", "Se agregó la información", "success");
        } 
    },    
  },
};
</script>